export const CONFETTI_DURATION_MS = 5000;
